import { api } from 'common';

export const sharedRestBlockDefaultConfig = {
  endpoint: 'https://jsonplaceholder.typicode.com/todos/1',
  method: 'GET' as const,
  secureHeaders: [],
  bodyFormat: api.FlowDefinition.RequestBodyFormat.RawJson,
  responseBodyFormat: api.FlowDefinition.ResponseBodyFormat.AutoDetect,
};
